import "./Separator.css";

const Separator = ({ text }) => {
  return <div className="text-divider extra-bold text-light">{text}</div>;
};

export default Separator;
